import { call, put, fork, all, takeEvery } from 'redux-saga/effects';
import { browserHistory } from 'edrolo/utils/browserHistory';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import * as API from './api';

export function* loadLessonByLessonId({ payload: { lessonId, isDemo } }) {
  yield put(actions.loadLessonByLessonId.request(lessonId, isDemo));
  try {
    const resp = yield call(API.loadLessonByLessonId, lessonId, isDemo);

    if (!resp.ok) {
      yield put(
        actions.loadLessonByLessonId.failure(
          lessonId,
          isDemo,
          resp.failureReason
        )
      );
    } else {
      yield put(
        actions.loadLessonByLessonId.success(lessonId, isDemo, resp.body)
      );
    }
  } catch (resp) {
    yield put(
      actions.loadLessonByLessonId.failure(lessonId, isDemo, 'Network Error')
    );
  }
}

export function* loadQuizStatsByLessonId({ payload: { lessonId } }) {
  yield put(actions.loadQuizStatsByLessonId.request(lessonId));
  try {
    const resp = yield call(API.loadQuizStatsByLessonId, lessonId);
    if (!resp.ok) {
      yield put(
        actions.loadQuizStatsByLessonId.failure(lessonId, resp.failureReason)
      );
    } else {
      yield put(actions.loadQuizStatsByLessonId.success(lessonId, resp.body));
    }
  } catch (resp) {
    yield put(
      actions.loadQuizStatsByLessonId.failure(lessonId, 'Network Error')
    );
  }
}

export function* loadQuizAttemptsByLessonId({ payload: { lessonId } }) {
  yield put(actions.loadQuizAttemptsByLessonId.request(lessonId));
  try {
    const resp = yield call(API.loadQuizAttemptsByLessonId, lessonId);
    if (!resp.ok) {
      yield put(
        actions.loadQuizAttemptsByLessonId.failure(lessonId, resp.failureReason)
      );
    } else {
      yield put(
        actions.loadQuizAttemptsByLessonId.success(lessonId, resp.body)
      );
    }
  } catch (resp) {
    yield put(
      actions.loadQuizAttemptsByLessonId.failure(lessonId, 'Network Error')
    );
  }
}

export function* saveQuizAttempt({
  payload: { lessonId, questionId, quizAttempt, callback },
}) {
  yield put(actions.saveQuizAttempt.request(lessonId, questionId, quizAttempt));
  try {
    const resp = yield call(API.saveQuizAttempt, quizAttempt.toJS());
    if (!resp.ok) {
      yield put(
        actions.saveQuizAttempt.failure(
          lessonId,
          questionId,
          quizAttempt,
          resp.failureReason
        )
      );
    } else {
      yield put(
        // second parameter here is returned/updated quiz attempt
        actions.saveQuizAttempt.success(lessonId, questionId, resp.body)
      );
      yield call(callback);
    }
  } catch (resp) {
    yield put(
      actions.saveQuizAttempt.failure(
        lessonId,
        questionId,
        quizAttempt,
        'Network Error'
      )
    );
  }
}

export function* loadChunkVisitsByLessonId({ payload: { lessonId } }) {
  yield put(actions.loadChunkVisitsByLessonId.request(lessonId));
  try {
    const resp = yield call(API.loadChunkVisitsByLessonId, lessonId);
    if (!resp.ok) {
      yield put(
        actions.loadChunkVisitsByLessonId.failure(lessonId, resp.failureReason)
      );
    } else {
      yield put(actions.loadChunkVisitsByLessonId.success(lessonId, resp.body));
    }
  } catch (resp) {
    yield put(
      actions.loadChunkVisitsByLessonId.failure(lessonId, 'Network Error')
    );
  }
}

export function* recordChunkVisit({ payload: { lessonId, chunkId } }) {
  yield put(actions.recordChunkVisit.request(lessonId, chunkId));
  try {
    const resp = yield call(API.recordChunkVisit, chunkId);

    if (!resp.ok) {
      yield put(
        actions.recordChunkVisit.failure(lessonId, chunkId, resp.failureReason)
      );
    } else {
      yield put(actions.recordChunkVisit.success(lessonId, chunkId, resp.body));
    }
  } catch (resp) {
    yield put(
      actions.recordChunkVisit.failure(lessonId, chunkId, 'Network Error')
    );
  }
}

export function* loadSuccessMeasureResponsesByLessonId({
  payload: { lessonId },
}) {
  yield put(actions.loadSuccessMeasureResponsesByLessonId.request(lessonId));
  try {
    const resp = yield call(
      API.loadSuccessMeasureResponsesByLessonId,
      lessonId
    );
    if (!resp.ok) {
      yield put(
        actions.loadSuccessMeasureResponsesByLessonId.failure(
          lessonId,
          resp.failureReason
        )
      );
    } else {
      yield put(
        actions.loadSuccessMeasureResponsesByLessonId.success(
          lessonId,
          resp.body
        )
      );
    }
  } catch (resp) {
    yield put(
      actions.loadSuccessMeasureResponsesByLessonId.failure(
        lessonId,
        'Network Error'
      )
    );
  }
}

export function* recordSuccessMeasureResponse({
  payload: { lessonId, profileId, successMeasureId, value, successNavigateUrl },
}) {
  yield put(
    actions.recordSuccessMeasureResponse.request(successMeasureId, value)
  );
  try {
    const resp = yield call(
      API.recordSuccessMeasureResponse,
      successMeasureId,
      value
    );

    if (!resp.ok) {
      yield put(
        actions.recordSuccessMeasureResponse.failure(
          lessonId,
          profileId,
          successMeasureId,
          value,
          resp.failureReason
        )
      );
    } else {
      yield put(
        actions.recordSuccessMeasureResponse.success(
          lessonId,
          profileId,
          successMeasureId,
          value,
          resp.body
        )
      );

      if (successNavigateUrl) {
        yield call(browserHistory.push, successNavigateUrl);
      }
    }
  } catch (resp) {
    yield put(
      actions.recordSuccessMeasureResponse.failure(
        lessonId,
        profileId,
        successMeasureId,
        value,
        'Network Error'
      )
    );
  }
}

// export function* watchLoadChunkView() {
//   yield takeEvery(actionTypes.LOAD_CHUNK_VIEW_SIGNAL, loadChunkView);
// }

export function* watchLoadLessonByLessonId() {
  yield takeEvery(
    actionTypes.LOAD_LESSON_BY_LESSON_ID_SIGNAL,
    loadLessonByLessonId
  );
}

export function* watchLoadQuizStatsByLessonId() {
  yield takeEvery(
    actionTypes.LOAD_QUIZ_STATS_BY_LESSON_ID_SIGNAL,
    loadQuizStatsByLessonId
  );
}

export function* watchLoadQuizAttemptsByLessonId() {
  yield takeEvery(
    actionTypes.LOAD_QUIZ_ATTEMPTS_BY_LESSON_ID_SIGNAL,
    loadQuizAttemptsByLessonId
  );
}

export function* watchSaveQuizAttempt() {
  yield takeEvery(actionTypes.SAVE_QUIZ_ATTEMPT_SIGNAL, saveQuizAttempt);
}

export function* watchLoadChunkVisitsByLessonId() {
  yield takeEvery(
    actionTypes.LOAD_CHUNK_VISITS_BY_LESSON_ID_SIGNAL,
    loadChunkVisitsByLessonId
  );
}

export function* watchRecordChunkVisit() {
  yield takeEvery(actionTypes.RECORD_CHUNK_VISIT_SIGNAL, recordChunkVisit);
}

export function* watchLoadSuccessMeasureResponsesByLessonId() {
  yield takeEvery(
    actionTypes.LOAD_SUCCESS_MEASURE_RESPONSES_BY_LESSON_ID_SIGNAL,
    loadSuccessMeasureResponsesByLessonId
  );
}

export function* watchRecordSuccessMeasureResponse() {
  yield takeEvery(
    actionTypes.RECORD_SUCCESS_MEASURE_RESPONSE_SIGNAL,
    recordSuccessMeasureResponse
  );
}

export default function* lessonsSagas() {
  yield all([
    // fork(watchLoadChunkView),
    fork(watchLoadLessonByLessonId),
    fork(watchLoadQuizStatsByLessonId),
    fork(watchLoadQuizAttemptsByLessonId),
    fork(watchSaveQuizAttempt),
    fork(watchLoadChunkVisitsByLessonId),
    fork(watchRecordChunkVisit),
    // success measures
    fork(watchLoadSuccessMeasureResponsesByLessonId),
    fork(watchRecordSuccessMeasureResponse),
  ]);
}
